export const clamp = (number: number, min: number, max: number) => {
  return Math.min(Math.max(number, min), max);
};

export const toFixed = (num: number | null | undefined, fixed = 2) => {
  if (num === undefined || num === null || isNaN(num)) {
    num = 0;
  }

  const re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');

  return parseFloat((num.toString().match(re) ?? ['0'])[0]);
};

export const parseFloatWithLocale = (locale: string, value: string) =>
  locale === 'cs'
    ? parseFloat(value.replace(/[\s]/g, '').replace(/[,]/g, '.') || '0')
    : parseFloat(value.replace(/[$,]/g, '') || '0');

export const parseIntWithLocale = (locale: string, value: string) =>
  locale === 'cs'
    ? parseInt(value.replace(/[\s]/g, '').replace(/[,]/g, '.') || '0', 10)
    : parseInt(value.replace(/[$,]/g, '') || '0', 10);

export const formatFloatWithLocale = (locale: string, value: string | number) => {
  let internalValue = typeof value === 'string' ? value : value.toString();

  if (locale === 'cs') {
    internalValue = internalValue.replace('.', ',');
  }

  return internalValue;
};
